import { z } from "zod";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../utils/route";
import { zUserInfo } from "@dobrh-monorepo/core";

export const requestSchema = z.object({
  email: z.string().toLowerCase(),
  password: z.string(),
  loginInfo: z
    .object({
      location: z.object({
        city: z.string().optional(),
        state: z.string().optional(),
        country: z.string().optional(),
        address: z.string().optional(),
      }),
      deviceId: z.string().optional(),
      deviceType: z.string().optional(),
      loginAt: z.coerce.date().optional(),
    })
    .optional(),
});

const responseSchema = z.union([
  z.object({
    message: z.string(),
    accessToken: z.string(),
    userProfile: zUserInfo,
  }),
  z.object({
    userId: z.string(),
    email: z.string(),
    emailRes: z.boolean(),
  }),
]);

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
